import GallectionSearchViewContainer from './GallectionSearchView.container';
import GallectionSearchView from './GallectionSearchView';

export default GallectionSearchViewContainer(GallectionSearchView);
